import { validator } from "LIB/validate-this";
import {
  CARRIER,
  CITY,
  COUNTRY,
  LINE1,
  POSTAL_CODE,
  SHIP_TO_COMPANY_ADDRESS_ID,
  SHIP_TO_COMPANY_ID,
  SHIPPING_ADDRESS,
  SHIPPING_METHOD,
  SHIPPING_TYPE
} from "APP_ROOT/constants";
import * as rules from "LIB/validation/rules";
import {
  COMPANY,
  DO_NOT_SHIP,
  DO_NOT_SHIP_REASONS,
  DROPSHIP
} from "MODULES/PurchaseOrders/constants";
import { REPAIR_STATION } from "MODULES/companies/constants";

const validateShippingFields = (values, form) => {
  form.validate(SHIPPING_TYPE).satisfies(rules.required);

  if (values.shipping_type === COMPANY) {
    form.validate(SHIP_TO_COMPANY_ID, SHIP_TO_COMPANY_ADDRESS_ID).required();
  }

  if (values.shipping_type === DROPSHIP) {
    form.validateChild(SHIPPING_ADDRESS, a => {
      a.validate(LINE1, CITY, POSTAL_CODE, COUNTRY).required();
    });
  }

  if (values.shipping_type === REPAIR_STATION) {
    form.validate("repair_station_physical_address_id").required();
  }

  if (values.shipping_type === DO_NOT_SHIP) {
    form.validate("_error").satisfies(() => {
      if (!DO_NOT_SHIP_REASONS.some(field => values[field])) {
        return "At least 1 DO NOT SHIP REASON selection is required";
      }

      return null;
    });
  } else {
    form.validateChild(SHIPPING_METHOD, s => {
      s.validate(CARRIER, SHIPPING_METHOD).satisfies(rules.required);
    });
  }
};

export default function validateShipping(values) {
  return validator(values, v => validateShippingFields(values, v));
}



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/ShippingDetails/EditShipping/validate.js